(function () {
    'use strict';

    function questionGroup($compile, $http, workflowProcessingService) {
        var templateUrl = 'workflow/directives/templates/questionGroup.html';

        return {
            restrict: 'E',
            scope: {
                InformationPart: '=informationPart'
            },
            link: function (scope, element) {
                scope.adminMode = false;
                scope.$watch(function () {
                    return workflowProcessingService.adminMode;
                }, function (newValue) {
                    scope.adminMode = newValue;
                });

                $http.get(templateUrl)
                      .then(function (response) {
                          element.html($compile(response.data)(scope));
                      });
            }
        };
    }

    questionGroup.$inject = ['$compile', '$http', 'workflowProcessingService'];

    angular.module('ecap.workflow').directive('questionGroup', questionGroup);
})();

